import { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import ImageModal from '../../../components/ImageModal';
import { useGlassData } from './useGlassData';

const GlassEnergy = ({ value, onChange, id = 'GlassEnergy', label = 'Glass Energy', disabled = false, showPics = false, appliesTo = 'windows' }) => {
    const defaultValue = value?.value || '';
    const [selectedGlassEnergy, setSelectedGlassEnergy] = useState(defaultValue);
    const [showModal, setShowModal] = useState(false);
    const { getGlassEnergy, loading, error } = useGlassData(appliesTo);

    const options = getGlassEnergy();

    // Update selected value when value prop changes
    useEffect(() => {
        setSelectedGlassEnergy(value?.value || '');
    }, [value]);

    // Trigger initial onChange once when options are loaded
    useEffect(() => {
        if (!loading && options.length > 0 && !selectedGlassEnergy) {
            const defaultOption = options[0];
            const newValue = defaultOption?.value || '';
            const newLabel = defaultOption?.label || '';
            setSelectedGlassEnergy(newValue);
            onChange({ value: newValue, label: newLabel });
        }
    }, [loading, options]);

    const handleGlassEnergyChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text.replace(' ✔', '');

        setSelectedGlassEnergy(newValue);
        onChange({ value: newValue, label: selectedText });
    };

    if (error) {
        console.error('Error loading glass energy:', error);
    }

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
                {showPics && (
                    <span
                        onClick={() => setShowModal(true)}
                        style={{
                            display: 'inline-block',
                            marginLeft: '6px',
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            backgroundColor: '#007bff',
                            color: '#fff',
                            textAlign: 'center',
                            lineHeight: '16px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            userSelect: 'none'
                        }}
                        title="Click to view image"
                    >
                        i
                    </span>
                )}
            </label>
            <select
                disabled={disabled || loading}
                id={id}
                value={selectedGlassEnergy}
                onChange={handleGlassEnergyChange}
            >
                {loading ? (
                    <option value="">Loading...</option>
                ) : (
                    options.map(option => (
                        <option key={option.id} value={option.value}>
                            {selectedGlassEnergy === option.value ? `${option.label} ✔` : option.label}
                        </option>
                    ))
                )}
            </select>
            <ImageModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                folder="images/GlassEnergy"
                imageName={selectedGlassEnergy}
                width={200}
                height={250}
            />
        </div>
    );
};

export default GlassEnergy;
